// extracted by mini-css-extract-plugin
export default {"defaultSelect":"DefaultSelect_defaultSelect__qiQBm","inputLabel":"DefaultSelect_inputLabel__m7idT"};